import { computed, reactive } from 'vue'
import { toTwoDecimalNumber, getNumberPart } from '@/utilities/currency'
import i18n from '@/engine/lang'

export const usePriceValueProxy = (inputValue?: number | null) => {
  interface Data {
    inputValue?: number | null
    stringValue?: string
    onModelChange?: ({ parsedValue, rawInput }: { parsedValue?: number, rawInput: string }) => void
  }

  const data: Data = reactive({
    inputValue
  })

  const computedPrice = computed<string | undefined>({
    get () {
      return String(data.inputValue ?? '').replaceAll('.', getNumberPart('decimal', i18n.locale))
    },
    set (value) {
      const numberCleaned = toTwoDecimalNumber(value?.toString?.() ?? '')

      data.inputValue = !isNaN(parseFloat(numberCleaned)) ? parseFloat(numberCleaned) : undefined
      data.stringValue = numberCleaned.replaceAll('.', getNumberPart('decimal', i18n.locale))

      data?.onModelChange?.({
        parsedValue: data.inputValue,
        rawInput: data.stringValue
      })
    }
  })

  function onModelChange (fn: Data['onModelChange'] = () => {}) {
    data.onModelChange = fn
  }

  return {
    onModelChange,
    computedPrice
  }
}
